/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component, useEffect } from "react";
import {Card, CardBody,CardTitle, Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
import * as XLSX from 'xlsx';
import history from '../../App/History';
import OrderResizableTable from './OrderResizableTable';
import { tableHeaderDataForUploadOrder as tableHeaderData, 
  tableImportOrderStatusHeader } from "../helper";

export default class ExcelImport extends Component {  
  constructor(props) {  
    
    super(props);
    this.input = React.createRef(); 
   // this.isLoading = false;
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = true;
    this.loading = false;
    this.isError = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    this.fileName = '';
    this.statusMethod = JSON.stringify(this.fillFileStatus());    
    this.state = {
      cols: [],
      rows: [],    
      statusData: [],
      isLoading: false,      
     regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "amazon-order-id",
          dataIndex: "amazon-order-id",
          editable: true,
          width: 180
        },
        {
          title: "merchant-order-id",
          dataIndex: "merchant-order-id",
          editable: true,
          width: 220
        },        
        {
          title: "purchase-date",
          dataIndex: "purchase-date",
          editable: true,
          width: 200
        },
        {
          title: "last-updated-date",
          dataIndex: "last-updated-date",
          editable: true,
          width: 200
        },
        {
          title: "order-status",
          dataIndex: "order-status",
          editable: true,
          width: 200
        },   
        {
          title: "fulfillment-channel",
          dataIndex: "fulfillment-channel",
          editable: true,
          width: 200
        },     
        {
            title: "sales-channel",
            dataIndex: "sales-channel",
            editable: true,
            width: 200
          },  
          {
            title: "order-channel",
            dataIndex: "order-channel",
            editable: true,
            width: 200
          },  
          {
            title: "url",
            dataIndex: "url",
            editable: true,
            width: 200
          },  
          {
            title: "ship-service-level",
            dataIndex: "ship-service-level",
            editable: true,
            width: 200
          },  
          {
            title: "product-name",
            dataIndex: "product-name",
            editable: true,
            width: 200
          },  
          {
            title: "sku",
            dataIndex: "sku",
            editable: true,
            width: 200
          },  
          {
            title: "asin",
            dataIndex: "asin",
            editable: true,
            width: 200
          },  
          {
            title: "item-status",
            dataIndex: "item-status",
            editable: true,
            width: 200
          },  
          {
            title: "quantity",
            dataIndex: "quantity",
            editable: true,
            width: 200
          },  
          {
            title: "currency",
            dataIndex: "currency",
            editable: true,
            width: 200
          },  
          {
            title: "item-price",
            dataIndex: "item-price",
            editable: true,
            width: 200
          },  {
            title: "item-tax",
            dataIndex: "item-tax",
            editable: true,
            width: 200
          },  {
            title: "shipping-price",
            dataIndex: "shipping-price",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-tax",
            dataIndex: "shipping-tax",
            editable: true,
            width: 200
          },  
          {
            title: "gift-wrap-price",
            dataIndex: "gift-wrap-price",
            editable: true,
            width: 200
          },  
          {
            title: "gift-wrap-tax",
            dataIndex: "gift-wrap-tax",
            editable: true,
            width: 200
          },  
          {
            title: "item-promotion-discount",
            dataIndex: "item-promotion-discount",
            editable: true,
            width: 200
          },  
          {
            title: "ship-promotion-discount",
            dataIndex: "ship-promotion-discount",
            editable: true,
            width: 200
          },  
          {
            title: "ship-city",
            dataIndex: "ship-city",
            editable: true,
            width: 200
          },  
          {
            title: "ship-state",
            dataIndex: "ship-state",
            editable: true,
            width: 200
          },  
          {
            title: "ship-postal-code",
            dataIndex: "ship-postal-code",
            editable: true,
            width: 200
          },  
          {
            title: "ship-country",
            dataIndex: "ship-country",
            editable: true,
            width: 200
          },  
          {
            title: "promotion-ids",
            dataIndex: "promotion-ids",
            editable: true,
            width: 200
          },  
          {
            title: "is-business-order",
            dataIndex: "is-business-order",
            editable: true,
            width: 200
          },  
          {
            title: "purchase-order-number",
            dataIndex: "purchase-order-number",
            editable: true,
            width: 200
          },  
          {
            title: "price-designation",
            dataIndex: "price-designation",
            editable: true,
            width: 200
          },  
          {
            title: "is-iba",
            dataIndex: "is-iba",
            editable: true,
            width: 200
          },  
          {
            title: "buyer-citizen-name",
            dataIndex: "buyer-citizen-name",
            editable: true,
            width: 200
          },  
          {
            title: "buyer-citizen-id",
            dataIndex: "buyer-citizen-id",
            editable: true,
            width: 200
          },  
          {
            title: "order-invoice-type",
            dataIndex: "order-invoice-type",
            editable: true,
            width: 200
          },  
          {
            title: "invoice-business-legal-name",
            dataIndex: "invoice-business-legal-name",
            editable: true,
            width: 200
          },  
          {
            title: "invoice-business-address",
            dataIndex: "invoice-business-address",
            editable: true,
            width: 200
          },  
          {
            title: "invoice-business-tax-id",
            dataIndex: "invoice-business-tax-id",
            editable: true,
            width: 200
          },  
          {
            title: "invoice-business-tax-office",
            dataIndex: "invoice-business-tax-office ",
            editable: true,
            width: 200
          }
      ]
    };
  }    

  calculateProcessingTime = (dateTimeString,modifiedDatetimeString) => {
    console.log(modifiedDatetimeString)

    const year = modifiedDatetimeString.substr(0, 4);
    let month = modifiedDatetimeString.substr(4, 2);
    let day = modifiedDatetimeString.substr(6, 2);
    let hour = modifiedDatetimeString.substr(8, 2);
    let minute = modifiedDatetimeString.substr(10, 2);
    let second = modifiedDatetimeString.substr(12, 2);
    if(modifiedDatetimeString.length > 12){
      month = modifiedDatetimeString.substr(4, 2);
      day = modifiedDatetimeString.substr(6, 2);
      hour = modifiedDatetimeString.substr(8, 2);
      minute = modifiedDatetimeString.substr(10, 2);
      second = modifiedDatetimeString.substr(12, 2);
    } else {
      month = modifiedDatetimeString.substr(4, 1);
      day = modifiedDatetimeString.substr(5, 1);
      hour = modifiedDatetimeString.substr(6, 2);
      minute = modifiedDatetimeString.substr(8, 2);
      second = modifiedDatetimeString.substr(10, 2);
    }
    
    if(hour > 12){
      hour -= 12;
    }

    const requestDate = new Date(dateTimeString)
    const modifiedDate = new Date(year, month - 1, day, hour, minute, second);
    const diff = modifiedDate.getTime() - requestDate.getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    const processingTime = `${hh}:${mm}:${ss}`;
    return processingTime;
  }

  fillFileStatus = async () => {
    console.log('start')
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
      Authorization: token }      
    };
  const response = await fetch('https://rss.getrael.com/api/amazon/orders/import/status', requestOptions);
  // const response = await fetch('http://localhost:8081/api/amazon/orders/import/status', requestOptions);
  const data = await response.json();
  
  if (data.code === '200')
  {
    console.log(data?.modal?.data)
    const currentDataByID = {}

    data?.modal?.data.forEach((item) => {
      if (item && currentDataByID[item?.uuid]) {
        currentDataByID[item?.uuid].push(item)
      }
      else {
        currentDataByID[item?.uuid] = [item]
      }
    });
    const currentUUID = Object.keys(currentDataByID);
    let finalData = []

    const reduceCallback = (acc, day) => {
      console.log(new Date(+day.dateTime))
      if (acc[day.statusChangeDateTime]) {
          acc?.[day.statusChangeDateTime]?.push(day)
      } else {
          acc[day.statusChangeDateTime] = [day]
      }
      return acc
  }

    for (let i = 0; i < currentUUID.length; i += 1) {
      const uuid = currentUUID[i];
      const currentMonth = currentDataByID?.[uuid] ?? [];
      const currentDateTimeWise = currentMonth?.reduce(reduceCallback, {});     
      const currentDate = Object.keys(currentDateTimeWise).sort((a,b) => b-a);     
      const dataAfterSort = currentDateTimeWise[currentDate[0]][0]
      finalData.push(currentDateTimeWise[currentDate[0]][0])      
  }

   
    finalData = finalData.map(item => ({
      ...item,
      processingTime: this.calculateProcessingTime(item.dateTime, item.statusChangeDateTime)
    }))    
    this.setState({
      statusData : finalData.sort((a,b) => new Date(b.dateTime).setHours(0, 0, 0, 0) - 
      new Date(a.dateTime).setHours(0, 0, 0, 0))
    })
  }  
  else {
    Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'File status not ready, Please try again!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
    console.log("File status not ready, Please try again!")
  }  
  }   
  
  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  // Updated Excel import function using XLSX
  onImportExcel = (event) => {
    const { files } = event.target;
    
    if (files.length === 1) {
      console.log(files[0].type)
      this.fileName = files[0].name
      console.log(this.fileName)
      
      // Check file type
      if (!(files[0].type === "application/vnd.ms-excel" || 
      files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      || files[0].type === "text/csv")) 
      {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        }); 
        this.setState({
          errorMessage: "Unknown file format. Only Excel files are uploaded!"
        });      
        return false;
      }

      // Read file using XLSX
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (jsonData.length < 2) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });
            return;
          }

          const newRows = [];
          
          // Process data rows (skip header row)
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              // Helper function to safely convert values to string
              const safeString = (value) => {
                if (value === null || value === undefined || value === '') {
                  return '';
                }
                return String(value);
              };

              newRows.push({
                key: index,
                amazonOrderId: safeString(row[0]),
                merchantOrderId: safeString(row[1]),                             
                purchaseDate: safeString(row[2]),
                lastUpdatedDate: safeString(row[3]),
                orderStatus: safeString(row[4]),
                fulfillmentChannel: safeString(row[5]),
                salesChannel: safeString(row[6]),
                orderChannel: safeString(row[7]),
                url: safeString(row[8]),
                shipServiceLevel: safeString(row[9]),
                productName: safeString(row[10]),
                sku: safeString(row[11]),
                asin: safeString(row[12]),
                itemStatus: safeString(row[13]),
                quantity: safeString(row[14]),
                currency: safeString(row[15]),
                itemPrice: safeString(row[16]),
                itemTax: safeString(row[17]),
                shippingPrice: safeString(row[18]),
                shippingTax: safeString(row[19]),
                giftWrapPrice: safeString(row[20]),
                giftWrapTax: safeString(row[21]),
                itemPromotionDiscount: safeString(row[22]),
                shipPromotionDiscount: safeString(row[23]),
                shipCity: safeString(row[24]),
                shipState: safeString(row[25]),
                shipPostalCode: safeString(row[26]),
                shipCountry: safeString(row[27]),
                promotionIds: safeString(row[28]),
                isBusinessOrder: safeString(row[29]),
                purchaseOrderNumber: safeString(row[30]),
                priceDesignation: safeString(row[31]),
                isIba: safeString(row[32]),    
                buyerCitizenName: safeString(row[33]),
                buyerCitizenId: safeString(row[34]),          
                orderInvoiceType: safeString(row[35]),
                invoiceBusinessLegalName: safeString(row[36]),
                invoiceBusinessAddress: safeString(row[37]),
                invoiceBusinessTaxId: safeString(row[38]),
                invoiceBusinessTaxOffice: safeString(row[39]),
              });                
            }
          });

          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: {top: 120, fontWeight: "bold"},
              });
            }); 
          } else {
            this.isError = false;
            this.isEmptyCell = true;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });            
          } else {
            this.isEmptyCell = false;
            
            this.setState({
              cols: jsonData[0] || [], // Headers
              rows: newRows,
              errorMessage: null
            });

            console.log(this.state.rows.length)
          }
          
        } catch (error) {
          console.error('Error reading file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading file. Please check file format.',
              duration: 10,
              style: {top: 120, fontWeight: "bold"},
              maxCount: 50
            });
          });
        }
      };
      
      reader.readAsArrayBuffer(files[0]);
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  }; 

  handleSubmit = async () => {
    this.state.isLoading = true;
    this.loading = true;
    this.isEmptyCell = true;
    console.log("submitting: ", this.state.rows);
    const token = localStorage.getItem('easydev');
    console.log(this.fileName)
    const requestData = {
      fileName: this.fileName,
      data: this.state.rows
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
      Authorization: token },
      body: JSON.stringify(requestData)
  };
  const response = await fetch('https://rss.getrael.com/api/amazon/orders/import', requestOptions);
  // const response = await fetch('http://localhost:8081/api/amazon/orders/import', requestOptions);
  const data = await response.json();
  this.setState({
    rows: [],
    errorMessage: null
  });
  this.fillFileStatus()
  console.log(data)
  console.log(data?.modal?.data)
    
      if (data.code === '200')
      {
        this.state.isLoading = false;
        this.loading = false;
       await Notification.newInstance({}, (notification) => {
          notification.notice({
            content: `${data?.modal?.data[0]?.fileName} ${data?.modal?.data[0]?.status}`,
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
        
      }
      else
      {
        this.state.isLoading = false;
        this.loading = false;
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: "File has not been imported! Please try again.",
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
      }        
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };
 
  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    const components = {
      body: {
      }
    };
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    return (
      <>
      <Col md={12}>            
          <Row className="product-table-wrap">   
            <Card className="pb-3">
              <CardBody className="dashboard__card-widget card-shadow p-3 mb-10">
                <Row>
                  <Col md="12">
                    <h4 className="bold-text text-center" tag="h3">Upload Order</h4>
                  </Col>
                </Row>
                <hr/>
                <Row>          
                <Col md="6">
                  <input className="file-uploader" type="file" accept=".xlsx, .xls, .csv" onChange={this.onImportExcel} 
                  ref={this.input} />
                  &nbsp;<Button className="btn btn-sm btn-danger"
                            style={{ marginTop: 16 }}
                            onClick={this.clearData}
                          >            
                          &nbsp;Clear
                        </Button> 
                </Col>
                <Col md="6" align="right">
                      <Button
                        onClick={this.handleSubmit}
                        size="large"
                        type="primary"
                        className="btn btn-primary btn-sm"
                        disabled={this.isEmptyCell}
                        style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                      >
                        {!this.loading && <span className='indicator-label'>Submit Data</span>}
                        {this.loading && (
                          <div className="smallload__icon-wrap">
                            <svg className="load__icon">
                                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                            </svg>
                          </div>
                        )}                        
                      </Button>
                  <Button
                        onClick={() => history.push('/amazon/order')}
                        size="large"
                        type="danger"
                        className="btn btn-primary btn-sm"
                        style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                      >
                      Back To Order
                  </Button>            
                </Col>  
                </Row>
                <hr/>
                <Row>       
                <Col md={12} lg={12}>
                    {this.state.rows.length ? (                      
                        <OrderResizableTable customClass="pt-0"
                        reactTableData={{tableHeaderData}} data={this.state.rows} type='file' />
                    ) : <div>No data preview available.
                    </div>}               
                </Col>
                </Row>
              </CardBody>
            </Card>
          </Row> 
          {this.state.statusData &&
          <>
            <Row className="product-table-wrap mt-10">
              <Card className="pb-3">
                <CardBody className="dashboard__card-widget card-shadow p-3">
                  <Col md={12} lg={12}>                  
                      <h4 className="bold-text text-center" tag="h3">
                      Imported file status
                      </h4>                   
                  </Col>
                  <hr/>
                  <Col md={12} lg={12}>                            
                      <OrderResizableTable customClass="pt-0"
                      reactTableData={{tableImportOrderStatusHeader}} 
                      data={this.state.statusData} type='status' />                            
                  </Col>
                </CardBody>
              </Card>
            </Row>            
          </>         
      }   
      </Col> 
    </>
    );
  }
}